export const breakpoints = {
  mobile: 576,
  tabletSmall: 768,
  tabletMedium: 992,
  desktop: 1200,
}
